export const useSxStyles = () => {
  return {
    content: {
      display: 'flex',
      flexGrow: 1,
      overflow: 'hidden',
    },
  };
};
